import api from './api';
import { CobrancaHistorico } from '../types';

export const cobrancaHistoricoService = {
  list(cobrancaId: number) {
    return api.get<CobrancaHistorico[]>('/cobrancas-historico', {
      params: { cobranca_id: cobrancaId }
    });
  },

  create(data: Partial<CobrancaHistorico>) {
    return api.post<CobrancaHistorico>('/cobrancas-historico', data);
  }
};

export default cobrancaHistoricoService;
